import React from "react";

import { FaRobot } from "react-icons/fa";

const MybotAvatar = () => {
  return (
    <div className="react-chatbot-kit-chat-bot-avatar">
      <div className="react-chatbot-kit-chat-bot-avatar-container">
        <FaRobot style={{ color: "white" }} />
      </div>
    </div>
  );
};

export default MybotAvatar;
